import React, { useState } from 'react';
import { ClipboardCheck, ShieldAlert } from 'lucide-react';
import { SkeletonDetail } from '../components/Skeleton';
import { useToast } from '../components/ToastProvider';
import { usePlaybookEditors } from '../features/admin/playbooks/usePlaybookEditors';
import TprmCriteriaEditor from '../features/admin/playbooks/TprmCriteriaEditor';
import KeyRiskCriteriaEditor from '../features/admin/playbooks/KeyRiskCriteriaEditor';

const TABS = [
  { key: 'key-risk', label: 'Contract playbooks', icon: ShieldAlert },
  { key: 'tprm', label: 'TPRM criteria', icon: ClipboardCheck },
];

export default function Playbooks() {
  const { showToast } = useToast();
  const { loading, error, tprm, keyRisk } = usePlaybookEditors({ showToast });
  const [tab, setTab] = useState('key-risk');

  const dirtyByTab = { tprm: tprm.dirty, 'key-risk': keyRisk.dirty };

  return (
    <div className="canvas-inner animate-fade-in">
      <div className="page-header">
        <div>
          <div className="page-eyebrow">Admin</div>
          <h1 className="page-title">Review playbooks</h1>
          <div className="page-subtitle">
            The standards the AI first-pass and the legal team judge against. Editing takes effect on the
            next review; completed first-passes are marked stale so reviewers know they predate the change.
          </div>
        </div>
      </div>

      {loading ? (
        <SkeletonDetail />
      ) : error ? (
        <div className="callout red"><div className="callout-body">{error}</div></div>
      ) : (
        <>
          <div className="tabs" role="tablist" aria-label="Review playbooks">
            {TABS.map((t) => {
              const Icon = t.icon;
              return (
                <button
                  key={t.key}
                  type="button"
                  role="tab"
                  aria-selected={tab === t.key}
                  className={tab === t.key ? 'active' : ''}
                  onClick={() => setTab(t.key)}
                >
                  <Icon className="w-4 h-4" />
                  {t.label}
                  {dirtyByTab[t.key] && (
                    <span
                      title="Unsaved changes"
                      style={{ width: 6, height: 6, borderRadius: 999, background: 'var(--color-yellow-500)', display: 'inline-block' }}
                    />
                  )}
                </button>
              );
            })}
          </div>

          {tab === 'key-risk' && <KeyRiskCriteriaEditor ctl={keyRisk} />}
          {tab === 'tprm' && <TprmCriteriaEditor ctl={tprm} />}
        </>
      )}
    </div>
  );
}
